import React, { Suspense } from "react";
import AppBar from "@material-ui/core/AppBar";
import { Toolbar, IconButton } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { Navigate } from "react-router-dom";
import { compose } from "recompose";
import Menu from "@material-ui/core/Menu";
import { observer, inject } from "mobx-react";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { getDataWithQueryString, getDataWithDeduplication, postData } from "../../../api/componentAPIs";
import Events from "../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import appConstants, { SESSION_STORAGE_KEYS } from "../../../appConstants";
import MESSAGES from "../../../appMessages";
import MoreVert from "@material-ui/icons/MoreVert";
import formatDate from "date-fns/format";
import Tooltip from "../../common/StyledToolTip";
import { format, isAfter } from "date-fns";
import { AppLoading } from "../../../loaders/loaders";
import styles from "../headerStyles";
import ModuleSwitcher from "../ModuleSwitcher";
import { groupBy } from "lodash";
import RightNavigationMenu from "./rightNavigationMenu";
import withWidth from "@material-ui/core/withWidth";
import RefreshIconButton from "../../common/RefreshIconButton";
import AnimationRenderer from "../../animations/animationRenderer";
import * as PrintAnimation from "../../animations/json/Printing.json";
import CustomSnackbarRenderer from "../../customSnackbars/customSnackbarRenderer";
import { RMAXLogger } from "../../../services/LoggerService/RMAXLogger";
import ShipmentSelection from "./components/ShipmentSelection";
import { withAppConfig } from "../../../appConfigContext";
import PreferredRouteWarningDialog from "../Dialogs/PreferredRouteWarningDialog/index";
import ParameterListener from "../Parameters";
import ShipmentSelectionMenu from "./components/ShipmentSelectionMenu";
import AddNewShipmentsOverlay from "../../modules/IBPlanning/RoutesView/AddNewShipmentsOverlay";
import NewShipmentsFeedbackPanel from "../../modules/IBPlanning/RoutesView/NewShipmentsFeedbackPanel";
import { getPlanDateIBEtaCutOff } from "../../modules/ShipmentSelection/PlanDateForm/utils";
import { getDefaultIBEtaCutOff } from "../../modules/ShipmentSelection/IBBills/utils";
import { APP_EVENT_NAMES } from "../../../signalR/constants";
import ETLComponent from "../../modules/Common/ETL"
import { getShipmentsDataByShipmentTypeAndFeatureFlags, getStopsDataByTypeAndFeatureFlags } from '../../modules/utils';
import withRouter from "../../../routes/withRouter";
import {
  getAnchorPointData,
  getTrailersData,
  getWavesData,
  getRoutesDataForPlanning
} from '../../../utilities/fetchData';
import { getAffectedRoutes } from "../Dialogs/DynamicRouting/components/utils";
import {
  getCityRoutesForScenario,
  removeCityRoutesForScenario
} from "../../../utilities/cityRoutesSessionStorage";
import { isPathInIBPlanning } from "../../modules/Common/ETL/Summary/summaryUtils";
const { IBPLANNING } = APP_EVENT_NAMES;

const PublishDialog = React.lazy(() => import("../Dialogs/PublishDialog"));
const DynamicRoutingManager = React.lazy(() =>
  import("../Dialogs/DynamicRouting/DynamicRoutingManager")
);
const DynamicRoutingFeedback = React.lazy(() =>
  import("../Dialogs/DynamicRoutingFeedback")
);

@inject("IBPlanningStore", "CommonStore")
@observer
class IbplanningHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTabValue:
        this.props.router.location.pathname
          ? this.props.router.location.pathname.toLowerCase()
          : false,
      isDataRefreshProgress: false,
      isETLRunningForFirstPush: false,
      currentPlanDate: null,
      isDialogOpen: false,
      title: "",
      dynamicRoutingProgressValue: 0,
      isDynamicRoutingInProgress: false,
      isDynamicRoutingCompleted: false,
      featureFlags: this.props.featureFlags ?? [],
      openDynamicRoutingFeedback: false,
      dynamicRoutingOutputData: {},
      preferredRouteWarningData: null,
      showNotificationPanel : false,
      showNewShipmentsNotification: false,
      newShipmentsUnreadCount : 0,
      ibEtaCutOff: null
      // isOptimizationRunning: false
    };
    this.tabValues = [
      appConstants.NAV_URLS.IBPLANNING_SHIPMENTS,
      appConstants.NAV_URLS.IBPLANNING_ROUTES,
      appConstants.NAV_URLS.IBPLANNING_CUSTOMERS,
    ];
    this.routesToPrint = [];
    this.printSnackbarkey = null;
    this.userProfileData = {
      terminal: this.props.userData.userProfile.terminal.code,
      userName: this.props.userData.userProfile.userName,
      planDate: this.props.userData.userProfile.planDate,
    };
  }
  componentDidMount() {
    const { IBPlanningStore } = this.props;
    !IBPlanningStore.staticClientData && this.populateClientCodesData();
    Events.on("RefreshIBStore", this.updateIBPlanningStore);
    Events.on(IBPLANNING.RoutingStatus, this.checkAndNotifyRoutingStatus);
    Events.on("RedirectToPage", this.handleChange);
    Events.on("OpenDynamicRoutingWithCityRoutes", this.handleOpenDynamicRoutingWithCityRoutes);
    Events.on(IBPLANNING.RoutePublishCompleted, this.checkAndNotifyPublishStatus);
    Events.on("RefreshKPI", this.getKPIGoals);
    Events.on("PublishNPrint", this.printNPublish);
    Events.on("OpenEditCustomerDialog", this.openCustomerDialog);
    Events.on("NewShipmentsDetected", this.handleNewShipmentsNotification);
    
    this.updateIBPlanningStore({
      refreshAdditionalData: {
        fetchAnchorPoint: true,
        fetchTrailerData: true,
        fetchWavesData: true
      }
    });
    this.loadInitializedPlanDates();
    this.getDriverPreferenceData();
    this.loadQuickFilters();
    const newShipments = JSON.parse(sessionStorage.getItem("newShipments"));
    if (
      newShipments &&
      newShipments.scenarioID &&
      this.props.userData.userProfile.scenarioID !== newShipments.scenarioID
    ) {
      const newShipmentsData = {
        scenarioID: this.props.userData.userProfile.scenarioID,
        data: [],
      };
      this.props.IBPlanningStore.updateNewShipments(newShipmentsData);
    }
    this.checkAndInitializeDynamicRoutingFromNavigation();
  }
  componentWillUnmount() {
    Events.removeListener("RefreshIBStore", this.updateIBPlanningStore);
    Events.removeListener(IBPLANNING.RoutingStatus, this.checkAndNotifyRoutingStatus);
    Events.removeListener("RedirectToPage", this.handleChange);
    Events.removeListener("OpenDynamicRoutingWithCityRoutes", this.handleOpenDynamicRoutingWithCityRoutes);
    Events.removeListener(
      IBPLANNING.RoutePublishCompleted,
      this.checkAndNotifyPublishStatus
    );
    Events.removeListener("RefreshKPI", this.getKPIGoals);
    Events.removeListener("PublishNPrint", this.printNPublish);
    Events.removeListener("OpenEditCustomerDialog", this.openCustomerDialog);
    Events.off("NewShipmentsDetected", this.handleNewShipmentsNotification);
  }

  componentDidUpdate(prevProps) {
    if (this.props.theme.themeName !== prevProps.theme.themeName) {
      if (this.props.IBPlanningStore.routesList.length > 0) {
        this.props.IBPlanningStore.addRoutes(
          this.props.IBPlanningStore.routesList,
          this.props.theme.routeMapColorPalette.IconsColors
        );
      }
    }
    if (
      this.props.userData.userProfile.terminal.id !==
        prevProps.userData.userProfile.terminal.id ||
      this.props.userData.userProfile.scenarioID !==
        prevProps.userData.userProfile.scenarioID
    ) {
      this.resetIBPlanningData();
      removeCityRoutesForScenario(prevProps.userData.userProfile.scenarioID);
      this.navigateWithPreservedCityRoutes(); //when we switch terminal or scenario revert path to original
      const dynamicRoutingCacheKey = `dynamicRoutingFormData_${prevProps.userData.userProfile.terminal.id}`;
      sessionStorage.getItem(dynamicRoutingCacheKey) &&
        sessionStorage.removeItem(dynamicRoutingCacheKey);
      const newShipmentsData = {
        scenarioID: this.props.userData.userProfile.scenarioID,
        data: [],
      };
      this.props.IBPlanningStore.updateNewShipments(newShipmentsData);
      this.resetNotificationCount()
      this.getDriverPreferenceData();
    }
    if (this.props.featureFlags !== prevProps.featureFlags) {
      this.setState({
        featureFlags: this.props.featureFlags,
      },this.loadInitializedPlanDates);
    }
    if (
      this.state.isDialogOpen &&
      prevProps.router.location.pathname !== this.props.router.location.pathname
    ) {
      this.shouldDialogOpen('', false);
    }
    const cityRoutes = this.getCityRoutesForDynamicRouting();
    // This will make sure that the dynamic routing dialog is auto opened when the user navigates to the routes view
    if (
      cityRoutes?.length > 0 &&
      prevProps.router.location.pathname !== this.props.router.location.pathname &&
      this.props.router.location.pathname === appConstants.NAV_URLS.IBPLANNING_ROUTES
    ) {
      RMAXLogger.info('DynamicRouting: ibplanningHeader.componentDidUpdate - auto open (path changed to routes)', {
        cityRoutes,
        prevPath: prevProps.router.location.pathname,
        currentPath: this.props.router.location.pathname
      });
      const isFromWithinIBPlanning = isPathInIBPlanning(prevProps.router.location.pathname);
      this.checkAndInitializeDynamicRoutingFromNavigation({ isFromWithinIBPlanning: Boolean(isFromWithinIBPlanning) });
    }
  }

  updateOptimizationRunTime = (queuedTime, runTime) => {
    const effectiveQueuedTime = queuedTime || 1;
    const effectiveRunTime = runTime || 1;
    this.optimizationRunTimeDetails = {queuedTime : effectiveQueuedTime, runTime: effectiveRunTime};
  }

  checkAndNotifyRoutingStatus = (
    scenarioId,
    isSuccess,
    dynamicRoutingProgressValue = 0,
    dynamicRoutingOutputData = {}
  ) => {
    if (
      scenarioId &&
      this.props.userData.userProfile.scenarioID === scenarioId
    ) {
      if (dynamicRoutingProgressValue) {
        !this.state.isDialogOpen && this.shouldDialogOpen("dynamicRouting");
        this.setState({
          isDynamicRoutingInProgress: true,
          dynamicRoutingProgressValue,
        });
      } else {
        this.props.CommonStore.updateIsOptimizationRunningFlag(false);
        if (!isSuccess) {
          this.closeDialog();
          this.props.enqueueSnackbar(`Optimization failed`, {
            variant: "error",
          });
        } else {
          removeCityRoutesForScenario(scenarioId);
          this.setState({
            isDynamicRoutingCompleted: isSuccess,
            openDynamicRoutingFeedback: true,
            dynamicRoutingOutputData
          });
        }
        this.updateIBPlanningStore({
          showNotification: false,
          selectedRoutesList: getAffectedRoutes(dynamicRoutingOutputData),
          refreshAdditionalData :{
            fetchAnchorPoint: true,
          }    
        });
      }
    }
  };
  checkAndNotifyPublishStatus = (scenarioId, terminalCode, isSuccess) => {
    if (
      scenarioId &&
      this.props.userData.userProfile.scenarioID === scenarioId
    ) {
      if (this.printSnackbarkey) {
        this.props.closeSnackbar(this.printSnackbarkey);
      }
      if (!isSuccess) {
        this.props.enqueueSnackbar(`${terminalCode} routes publish failed`, {
          variant: "error",
        });
      } else {
        if (this.props.IBPlanningStore.isPrintManifestInProgress) {
          this.printLoadingManifest();
        } else {
          this.props.enqueueSnackbar(`${terminalCode} routes published`, {
            variant: "success",
            persist: true,
          });
        }
      }
      this.props.IBPlanningStore.setIsPrintManifestInProgress(false);
      this.props.IBPlanningStore.setIsPublishInProgress(false);
      this.routesToPrint = [];
    }
  };

  getIBPlanningStoreUpdatePromises = ({
    scenarioID,
    planDate,
    getNewBills,
    selectedShipmentsList
  }) => {
    const routesPromise = getRoutesDataForPlanning(scenarioID);
    const stopsPromise = scenarioID
      ? getDataWithDeduplication('StopsGrid', `scenarioId=${scenarioID}`)
      : Promise.resolve({ status: 200, data: [] });
    const shipmentPromise =
      scenarioID && planDate
        ? getDataWithDeduplication(
            'ShipmentsGrid',
            `scenarioId=${scenarioID}&planDate=${planDate}`
          ).then((response) => {
            if (response.status === 200) {
              this.props.IBPlanningStore.addShipments(
                getShipmentsDataByShipmentTypeAndFeatureFlags(response.data, this.props.configJSON),
                this.props.configJSON.enableHoldPros
              );
              selectedShipmentsList &&
                this.props.IBPlanningStore.updateSelectedShipments(selectedShipmentsList);
            }
            return response;
          })
        : (() => {
            this.props.IBPlanningStore.addShipments([],this.props.configJSON.enableHoldPros);
            return Promise.resolve({ status: 200, data: [] });
          })();
    const newBillsPromise =
      getNewBills && scenarioID
        ? getDataWithQueryString('GetNewShipments', `scenarioId=${scenarioID}`)
        : Promise.resolve({ data: [] });

    return [routesPromise, stopsPromise, shipmentPromise, newBillsPromise];
  };

  resetIBPlanningData = () => {
    if(this.state.isDataRefreshProgress){
      return
    }
    this.props.IBPlanningStore.showErrorMessageOnGrid('all', appConstants.GRID_STATUS.LOADING);
    this.props.IBPlanningStore.addShipments([],this.props.configJSON.enableHoldPros);
    this.props.IBPlanningStore.refreshDataSources({
      routesData: [],
      stopsData: [],
      filteredRouteStops: [],
      iconsColor: [],
      planDate: this.props.userData.userProfile.planDate,
      enableHoldPros: this.props.configJSON.enableHoldPros
    });
  };

  isEnforcedDynamicRoutingEnabled = () => {
    return Boolean(
      this.state.featureFlags.find(
        (ele) => ele.id === appConstants.features.EnableEnforcedDynamicRoutingFromShipmentSelection
      )?.value
    );
  };

  getCityRoutesForDynamicRouting = () => {
    if (!this.isEnforcedDynamicRoutingEnabled()) return [];
    const fromNavState = this.props.router?.location?.state?.cityRoutes;
    if (fromNavState?.length > 0) return fromNavState;
    const scenarioID = this.props.userData?.userProfile?.scenarioID;
    return scenarioID ? getCityRoutesForScenario(scenarioID) : [];
  };

  updateIBPlanningStore = async ({
    showNotification = false,
    selectedRoutesList = [],
    selectedShipmentsList = [],
    getNewBills = false,
    refreshAdditionalData = {
      fetchAnchorPoint: false,
      fetchTrailerData: false,
      fetchWavesData: false
    }    
  }={}) => {
    const { scenarioID, planDate, terminal } = this.props.userData.userProfile;

    this.props.IBPlanningStore.updateDataRefreshProgress(true);

    // If one of route/ routesStop get bit delayed the data on UI will be out of sync between route and routeStops causing multiple rerenders of Map
    //, which causes multiple calls to mapbox directions API
    Promise.all(
      this.getIBPlanningStoreUpdatePromises({
        scenarioID,
        planDate,
        getNewBills,
        selectedShipmentsList
      })
    )
      .then(
        ([routes, stops, shipments, newBills]) => {
          if (routes.status === 200 && stops.status === 200 && shipments.status === 200) {
            const updatedDataSources = this.prepareUpdatedDataSources({
              routes,
              stops,
              newBills,
              getNewBills,
              scenarioID,
              planDate
            });
            //Update data sources in IBPlanning Store with new data available
            this.props.IBPlanningStore.refreshDataSources(updatedDataSources);
            
            const cityRoutes = this.getCityRoutesForDynamicRouting();
            this.updateSelectedRoutesInStore(cityRoutes, selectedRoutesList);
            if (showNotification) {
              this.props.enqueueSnackbar(MESSAGES.COMMON.DATA_REFRESHED, { variant: 'info' });
            }
            //For new bills added notification snackbar
            if (getNewBills) {
              this.handleNewBillsNotification(newBills);
            }
          } else {
            //reset shipment/route/stop data if api call failed
            this.props.IBPlanningStore.addShipments([],this.props.configJSON.enableHoldPros);
            this.props.IBPlanningStore.refreshDataSources({
              routesData: [],
              stopsData: [],
              filteredRouteStops: [],
              iconsColor: [],
              planDate: this.props.userData.userProfile.planDate,
              enableHoldPros: this.props.configJSON.enableHoldPros
            });
          }
          this.updateDataLoadStatus();
        },
        (error) => {
          this.updateDataLoadStatus();
        }
      )
      .catch((error) => {
        console.error('Error in Promise.all for refreshIBPlanningData call:', error);
      });
      
    if (scenarioID) {
      await this.fetchAdditionalData({
        scenarioID,
        terminal,
        refreshAdditionalData
      });
    } else {
      this.props.CommonStore.updateAnchorPointsData([], terminal.code);
      this.props.CommonStore.updateTrailersData([]);
      this.props.CommonStore.updateWaveData([]);
    }
    
    this.getKPIGoals();
  };

  prepareUpdatedDataSources = ({routes, stops, newBills, getNewBills, scenarioID, planDate}) => {
    //Update data sources in IBPlanning Store with new data available
    const newShipmentsData = {
      scenarioID,
      data: getNewBills ? newBills.data : []
    };

    return {
      routesData: routes.data,    
      stopsData: getStopsDataByTypeAndFeatureFlags(stops.data, this.props.configJSON),
      newShipments: newShipmentsData,
      iconsColor: this.props.theme.routeMapColorPalette.IconsColors,
      planDate,
      getNewBills,
      enableHoldPros: this.props.configJSON.enableHoldPros
    };
  };


  handleNewBillsNotification = (newBills) => {
    const routesAffected = groupBy(
      newBills.data.filter(
        (newShipment) => newShipment.routeName !== appConstants.UNRTD_ROUTENAME
      ),
      "routeName"
    );
    const affectedRoutesLength = Object.keys(routesAffected).length;
  
    if (newBills.data.length || affectedRoutesLength) {
      this.props.enqueueSnackbar(
        `${affectedRoutesLength} Routes got affected. ${newBills.data.length} Shipments got added.`,
        { variant: "success" }
      );
    }
  };

  fetchAdditionalData = async ({
    scenarioID,
    terminal,
    refreshAdditionalData
  }) => {
    if (refreshAdditionalData.fetchAnchorPoint) {
      let { data: anchorPointData } = await getAnchorPointData(scenarioID, terminal);
      this.props.CommonStore.updateAnchorPointsData(anchorPointData, terminal.code);
    }
    if (refreshAdditionalData.fetchTrailerData) {
      let trailerData = await getTrailersData(terminal);
      this.props.CommonStore.updateTrailersData(trailerData);
    }
    if (refreshAdditionalData.fetchWavesData) {
      this.props.CommonStore.setWavesDataLoaded(false);
      try {
        let wavesData = await getWavesData(scenarioID);
        this.props.CommonStore.updateWaveData(wavesData);
      } catch {
        this.props.CommonStore.updateWaveData([]);
      }
    }
  };

  updateDataLoadStatus = () => {
    this.props.IBPlanningStore.updateDataRefreshProgress(false);
    this.props.IBPlanningStore.setdisableStoreUpdate(false);
    this.props.IBPlanningStore.showErrorMessageOnGrid('all', appConstants.GRID_STATUS.SUCCESS);
  }

  loadQuickFilters = () => {
    if(this.props.IBPlanningStore.quickFilterList.length > 0) {
      // quick filter list is already loaded
      return;
    }
    getDataWithQueryString(
      'GetQuickFilters',
      `terminalId=${this.props.userData.userProfile.terminal.id}`
    ).then(
      (response) => {
        if (response.status === 200) {
          this.props.IBPlanningStore.updateQuickFilterList(response.data);
        } else {
          this.props.IBPlanningStore.updateQuickFilterList([]);
        }
      },
      (error) => {
        this.props.IBPlanningStore.updateQuickFilterList([]);
      }
    );
  };

  getDriverPreferenceData = () => {
    const { scenarioID } = this.props.userData.userProfile;
    if (!scenarioID) {
      this.setDriverPreferences([]);
      return;
    }
    getDataWithQueryString('GetDriverPreferences', `scenarioId=${scenarioID}`).then(
      (response) => {
        if (response.status === 200) {
          this.setDriverPreferences(response.data);
          return;
        }
        this.setDriverPreferences([]);
      },
      (_error) => {
        this.setDriverPreferences([]);
      }
    );
  };

  setDriverPreferences = (driverData) => {
    this.props.IBPlanningStore.setDriverPreferencesList(driverData);
  };

  getKPIGoals = () => {
    const { scenarioID } = this.props.userData.userProfile;
    if (!scenarioID) {
      this.props.IBPlanningStore.updateKPIData([]);
      return;
    }
    getDataWithDeduplication("IBKPIs", `scenarioId=${scenarioID}`).then(
      (response) => {
        if (response && response.status === 200) {
          this.props.IBPlanningStore.updateKPIData(response.data);
        } else {
          this.props.IBPlanningStore.updateKPIData([]);
        }
      }
    );
  };

  populateClientCodesData=()=>{
    getDataWithQueryString("GetClientCodes").then(
      (response) => {
        if (response && response.status === 200) {
          this.props.IBPlanningStore.setStaticClientData(response.data);
        } else {
          this.props.IBPlanningStore.setStaticClientData(null);
        }
      }
    );
  }

  handleChange = (event, currentTabValue, activeModule=null) => {
    this.setState({
      currentTabValue,
    });
    if (activeModule) {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.ACTIVE_SETTINGS_MODULE, activeModule);
    }
  };

  openAddUpdateProToPlan=(value)=>{
    this.props.router.navigate(`?proMode=${value}`,{
      state: this.getPreservedNavigationState({
        ibEtaCutOff: this.state.ibEtaCutOff
      })
    });
  };

  onTerminalChange = (terminal) => {
    sessionStorage.setItem("selectedTerminal", terminal.terminalId);
    this.props.glEventHub &&
      this.props.glEventHub.emit("DispatchEvents", "RefreshUserInfo", [
        terminal.terminalId,
        `Switched to terminal ${terminal.terminalCode}`,
      ]);
    this.updateSelectedRoutesInStore([], []);
    this.props.IBPlanningStore.updateSelectedShipments([]);
    this.setState({
      mainMenuAnchor: null,
    });
  };

  openModuleSwitcher = (event) => {
    this.setState({ moduleSwitcherAnchor: event.currentTarget });
  };

  onModuleSwitcherClose = () => {
    this.setState({ moduleSwitcherAnchor: null });
  };
  shouldDialogOpen = (title, open = true) => {
    //resetting dynamic routing states to their initial values on mounting of the dynamic routing dialog
    if (title === "dynamicRouting") {
      this.resetDynamicRoutingValues();
    }

    this.setState({
      title: title,
      isDialogOpen: open,
    });
  };

  resetDynamicRoutingValues = () => {
    this.setState({
      isDynamicRoutingInProgress: false,
      isDynamicRoutingCompleted: false,
      dynamicRoutingProgressValue: 0,
    });
  };

  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
    });
  };

  getDialogComponent = (title) => {
    switch (title) {
      case "publish":
        return (
          <PublishDialog
            show={this.state.isDialogOpen}
            onClose={() => this.closeDialog()}
            publish={() => this.publishRoutes()}
            configJSON={this.props.configJSON}
          />
        );
      case "dynamicRouting":
        return (
          <DynamicRoutingManager
            show={this.state.isDialogOpen}
            onClose={this.closeDialog}
            triggerDynamicRouting={this.triggerDynamicRouting}
            dynamicRoutingProgressValue={this.state.dynamicRoutingProgressValue}
            inProgress={this.state.isDynamicRoutingInProgress}
            isCompleted={this.state.isDynamicRoutingCompleted}
            updateOptimizationRunTime={this.updateOptimizationRunTime}
            themeName={this.props.theme.themeName}
            glEventHub={this.props.glEventHub}
            handleDynamicRoutingError={this.handleDynamicRoutingError}
            userData={this.props.userData}
          />
        );
      case "PreferredRouteWarning":
        return (
          <PreferredRouteWarningDialog
            show={this.state.isDialogOpen}
            onClose={this.closeDialog}
            preferredRouteWarningData={this.state.preferredRouteWarningData}
            openCustomerDialog={this.openCustomerDialog}
          />
        );
      default:
        return "";
    }
  };

  openCustomerDialog = (customerCode, activeTabLabel) => {
    if (!customerCode) {
      return null;
    }
    this.props.router.navigate(
      `${this.props.router.location.pathname}?customerCode=${customerCode}`,
      { state: this.getPreservedNavigationState({ activeTabLabel }) }
    );
    if (this.state.isDialogOpen) { 
      this.closeDialog(); // Closing another dialog if any dialog is open while opening edit customer
    }
  }

  publishRoutes = (showNotification = true) => {
    RMAXLogger.info("PublishRoute button clicked");
    const userProfile = this.props.userData.userProfile;
    this.props.IBPlanningStore.setIsPublishInProgress(true);
    postData("PublishRoutes", {
      scenarioId: userProfile.scenarioID,
      planDate: userProfile.planDate,
    }).then(
      (response) => {
        if (response && response.status === 200) {
          showNotification &&
            this.props.enqueueSnackbar(MESSAGES.ROUTE_PUBLISH.START_SUCCESS, {
              variant: "success",
            });
        } else {
          this.handlePublishRoutesError(response.status);
        }
      },
      () => {
        this.handlePublishRoutesError();
      }
    );
    this.closeDialog();
    RMAXLogger.info("PublishRoutes");
  };

  handlePublishRoutesError = (statusCode) => {
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(MESSAGES.ROUTE_PUBLISH.START_FAILURE, {
      variant: "error",
    });  
  }


  triggerDynamicRouting = (configData) => {
    this.props.CommonStore.updateIsOptimizationRunningFlag(true);

    const reqObj = {
      terminal: this.props.userData.userProfile.terminal.code,
      scenarioId: this.props.userData.userProfile.scenarioID,
    };
    this.setState({
      isDynamicRoutingInProgress: true,
    });
    postData(`TriggerDynamicRouting`, { ...configData, ...reqObj }).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          return;
        }

        this.handleDynamicRoutingError(response);
      },
      () => {
        this.handleDynamicRoutingError();
      }
    );

    RMAXLogger.info("DynamicRouting", { config: configData });
  };

  handleDynamicRoutingError = (errorResponse) => {
    const statusCode = errorResponse?.response?.status;
    const errorMessage = errorResponse?.response?.data?.error?.message;
  
    const isPreferredRouteWarningPresent = this.checkAndHandlePreferredRouteConflict(statusCode, errorMessage);

    // If the preferred route warning is present, we don't want to do the remaining error handling
    if(isPreferredRouteWarningPresent ) return;
  
    // General error handling
    this.resetDynamicRoutingValues();
    this.closeDialog();
    this.props.CommonStore.updateIsOptimizationRunningFlag(false);
  
    if (statusCode === 403) {
      return;
    }
  
    // Base message
    let snackbarMessage = MESSAGES.ROUTE_OPTIMIZATION.START_FAILURE;
  
    // Append only if it's a plain string, not a JSON string
    if (errorMessage && typeof errorMessage === 'string') {
      try {
        JSON.parse(errorMessage); // valid JSON → skip appending
      } catch {
        snackbarMessage += `: ${errorMessage}`; // not JSON → append it
      }
    }
  
    this.props.enqueueSnackbar(snackbarMessage, {
      variant: "error",
    });
  };

  checkAndHandlePreferredRouteConflict = (statusCode, errorMessage) => {
    // Try handling preferred route warning (409 with JSON error message)
    if (
      statusCode === 409 &&
      errorMessage
    ) {
      try {
        const conflictedShipments = JSON.parse(errorMessage);
        if (Array.isArray(conflictedShipments) && conflictedShipments.length) {
          this.setState(
            { preferredRouteWarningData: conflictedShipments },
            () => this.shouldDialogOpen("PreferredRouteWarning", true)
          );
          this.props.CommonStore.updateIsOptimizationRunningFlag(false);

          // Return true to indicate that the preferred route warning was present
          return true;
        }
      } catch (ex) {
        console.log("Unable to parse json")
      }
    }
    return false;
  }


  openMainMenu = (event) => {
    this.setState({ mainMenuAnchor: event.currentTarget });
  };

  closeMainMenu = () => {
    this.setState({ mainMenuAnchor: null });
  };

  printNPublish = () => {
    const selectedRoutesCount =
      this.props.IBPlanningStore.selectedRouteNameList.length;
    if (selectedRoutesCount) {
      const  { isReadOnlyRole }  = this.props.userData.userProfile;
      if (!isReadOnlyRole) {
        this.printSnackbarkey = this.props.enqueueSnackbar(
          `Loading manifest printing is in progress`,
          {
            variant: "info",
            persist: true,
            content: (key) => (
              <CustomSnackbarRenderer
                animation={
                  <AnimationRenderer
                    animationJSON={PrintAnimation}
                    dimension="30px"
                  />
                }
                snackbarLabel="Printing is in progress"
                id={key}
              />
            ),
          }
        );
      }
      this.props.IBPlanningStore.setIsPrintManifestInProgress(true);
      const selectedRoutesToPrint = [
        ...this.props.IBPlanningStore.selectedRouteNameList,
      ];
      selectedRoutesToPrint.forEach((routeName) => {
        const routeNameAndWave = routeName.split("_");
        this.routesToPrint.push({
          routeName: routeNameAndWave[0],
          wave: routeNameAndWave.length > 1 ? routeNameAndWave[1] : 0,
        });
      });
      //Initiate a publish
      this.publishRoutes(false);
    } else {
      this.props.enqueueSnackbar(MESSAGES.COMMON.NO_ROUTE_SELECTED, {
        variant: "info",
      });
    }
  };
  printLoadingManifest = () => {
    const routesToPrint = this.getDeduplicatedManifest();
    if (routesToPrint.length > 0) {
      postData("PrintLoadingManifest", {
        scenarioId: this.props.userData.userProfile.scenarioID,
        plandate: this.props.userData.userProfile.planDate,
        routes: routesToPrint,
      }).then(
        (response) => {
          if (Math.trunc(response.status / 100) === 2) {
            this.props.enqueueSnackbar(`Printing completed`, {
              variant: "success",
              persist: false,
            });
          } else {
            this.handlePrintLoadingManifestError(response.status);
          }
        },
        () => {
          this.handlePrintLoadingManifestError();
        }
      );

      RMAXLogger.info("LoadingManifestPrint", {
        routesToPrint
      });
    }
  };

  handlePrintLoadingManifestError = (statusCode) => {
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(`Error while printing loading manifest`, {
      variant: "error",
      persist: false,
    });  
  }

  getDeduplicatedManifest = () => {
    const uniqueKeys = new Set();
    const deduplicatedArray = this.routesToPrint.filter((item) => {
      const key = `${item.routeName}-${item.wave}`;
      if (uniqueKeys.has(key)) {
        return false;
      }
      uniqueKeys.add(key);
      return true;
    });
    return deduplicatedArray;
  }

  closeDynamicRoutingFeedback = () => {
    //close dynamic routing feedback dialog and reset all related data
    this.setState({
      openDynamicRoutingFeedback: false,
      dynamicRoutingOutputData: {}
    });
  };

  getPreservedNavigationState = (additionalState = {}) => {
    const currentState = this.props.router.location.state || {};
    const { cityRoutes: _cityRoutes, ...restState } = currentState;
    return { ...restState, ...additionalState };
  };

  navigateWithPreservedCityRoutes = () => {
    this.props.router.navigate(this.props.router.location.pathname, {
      replace: true,
      state: this.getPreservedNavigationState()
    });
  };

  handleOpenDynamicRoutingWithCityRoutes = () => {
    this.checkAndInitializeDynamicRoutingFromNavigation({ isFromWithinIBPlanning: true });
  };

  // If we're on routes view and have city routes (session/nav), open Dynamic Routing and optionally sync store selection; see docs/features/SHIPMENT_SELECTION_TO_OPTIMIZATION.md
  checkAndInitializeDynamicRoutingFromNavigation = (options = {}) => {
    const cityRoutes = this.getCityRoutesForDynamicRouting();
    const shouldOpenDynamicRoutingDialog = cityRoutes?.length > 0 && !this.state.isDialogOpen;
    if(!shouldOpenDynamicRoutingDialog) return;
    const pathname = this.props.router?.location?.pathname?.toLowerCase?.();
    if (pathname === appConstants.NAV_URLS.IBPLANNING_ROUTES) {
      const isFromWithinIBPlanning = options.isFromWithinIBPlanning === true;
      if (isFromWithinIBPlanning) {
        this.updateSelectedRoutesInStore(
          cityRoutes,
          this.props.IBPlanningStore.selectedRouteNameList
        );
      }
      this.shouldDialogOpen("dynamicRouting", true);
    } else {
      // When user is in IB Planning on shipments or customers (or landed from dispatch) with pending city routes, redirect to routes so DR dialog can auto-open
      Events.emit('RedirectToPage', null, appConstants.NAV_URLS.IBPLANNING_ROUTES);
    }
  };

  updateSelectedRoutesInStore = (cityRoutes, selectedRoutesList) => {
    this.props.IBPlanningStore.updateSelectedRoutes(
      cityRoutes?.length > 0 ? cityRoutes : (selectedRoutesList ?? [])
    );
  };

  openMenu = (event) => {
    this.setState({ menuAnchor: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ menuAnchor: null });
  };

  loadInitializedPlanDates = () => {
    if(!this.isShipmentSelectionEnabled()){
      return;
    }
    const {
      userData: { userProfile },
    } = this.props;
    getDataWithQueryString(
      "GetInitializedPlanDates",
      `terminalId=${userProfile.terminal.id}`
    ).then((response) => {
      if (response?.status === 200) {
        const ibEtaCutOff = getDefaultIBEtaCutOff({
          ibEtaCutOff: getPlanDateIBEtaCutOff(
            response.data,
            this.props.userData.userProfile.planDate
          ),
          planDate: this.props.userData.userProfile.planDate,
          defaultIBEtaCutOffTimeInMinutes:
            this.props.userData?.userProfile?.defaultIbEtaCutOffInMins ?? 0,
        });
        this.setState({ibEtaCutOff})
        this.getNewShipmentsData(ibEtaCutOff);
        this.updateUrlState(ibEtaCutOff);
      }
    });
  };

  updateUrlState = (ibEtaCutOff) => {
    const searchParams = new URLSearchParams(this.props.router.location.search);
    const proMode = searchParams.get('proMode');
    if (proMode) {
      this.props.router.navigate(`?proMode=${proMode}`, {
        state: this.getPreservedNavigationState({ ibEtaCutOff }), // The updated state
        replace: true // Replace the current entry in history
      });
    }
  };

  getNewShipmentsData = (ibEtaCutOff) => {
    const {
      userData: { userProfile },
    } = this.props;
    getDataWithQueryString(
      "GetShipmentsToAdd",
      `terminalId=${userProfile.terminal.id}&terminalCode=${userProfile.terminal.code}&planDate=${userProfile.planDate}&ibEtaCutOff=${ibEtaCutOff}`
    ).then(
      (newShipments) => {
        if (newShipments?.status === 200 && newShipments?.data?.length > 0) {
          this.handleNewShipmentsNotification(
            userProfile.terminal.code,
            userProfile.planDate,
            false
          );
        }
      }
    );
  };


  toggleNotificationPanel = () => {
    this.setState((prevState) => ({
      showNotificationPanel: !prevState.showNotificationPanel,
    }),this.resetNotificationCount());
  };

  onCloseNewShipmentsFeedbackPanel = () => {
    if (this.newShipmentsDetectedKey !== null) {
      this.props.closeSnackbar(this.newShipmentsDetectedKey);
      this.newShipmentsDetectedKey = null;
    }
  };

  showNewShipmentsToastNotification = () => {
    this.props.closeSnackbar();
    if (!this.state.showAddNewShipments && !this.state.showNotificationPanel) {
      this.newShipmentsDetectedKey = this.props.enqueueSnackbar(
        "New Shipments are available",
        {
          children: (
            <NewShipmentsFeedbackPanel
              handleAddClick={this.showAddNewShipments}
              onClose={this.onCloseNewShipmentsFeedbackPanel}
            />
          ),
          autoHideDuration: appConstants.SNACKBAR_AUTO_HIDE_DURATION,
          style: { pointerEvents: "none" },
        }
      );
    }
  };

  handleNewShipmentsNotification =(
    terminalCode,
    planDate,
    showToastNotification = true
  ) => {
    if(!this.isShipmentSelectionEnabled()){
      return;
    }
    const {
      userData: { userProfile },
    } = this.props;
    if (
      terminalCode === userProfile.terminal.code &&
      format(planDate, "yyyy-MM-dd") === userProfile.planDate &&
      !this.state.currentTabValue?.includes?.("reports")
    ) {
      showToastNotification && this.showNewShipmentsToastNotification();
      this.setState({
        newShipmentsUnreadCount: 1,
      });
      !this.state.showNewShipmentsNotification &&
        this.setState({
          showNewShipmentsNotification: true,
        });
    }
  };

  resetNotificationCount = () => {
    this.setState({
      newShipmentsUnreadCount : 0
    })
  }

  showAddNewShipments = () => {
      this.setState(
        {
          showAddNewShipments: true,
          showNotificationPanel: false,
        },
        () =>
          this.state.newShipmentsUnreadCount > 0 &&
          this.resetNotificationCount()
      );
      this.props.closeSnackbar();
  };

  closeAddNewShipmentsPopup = () => {
    this.setState({
      showAddNewShipments: false,
    });
  };

  updateDataRefreshingStatus = (isDataRefreshProgress, isDialogOpen) => {
    this.setState((prevState) => ({
      isDataRefreshProgress,
      isDialogOpen: isDialogOpen ?? prevState.isDialogOpen
    }));
  }

  isValidFirstPush = ({isFirstPush,planDate}) => {
    const {
      userData: { userProfile }
    } = this.props;
    return isFirstPush && (!userProfile.planDate || isAfter(planDate, userProfile.planDate));
  }

  refreshIBPlanningData = () =>
    this.updateIBPlanningStore({
      showNotification: false,
      selectedRoutesList: this.props.IBPlanningStore.selectedRouteNameList,
      selectedShipmentsList: this.props.IBPlanningStore.selectedShipmentIDList,
      getNewBills: true
    });

    isShipmentSelectionEnabled = () => {
      return this.state.featureFlags.find(
        (ele) => ele.id == appConstants.features.EnableShipmentSelection
      )?.value
    }

  render() {
    const { moduleSwitcherAnchor, mainMenuAnchor } =
      this.state;
    const { classes } = this.props;
    const dynamicRoutingFeatureFlag = this.state.featureFlags.find(
      (ele) => ele.id == "DynamicRouting"
    );
    let enableDynamicRouting = false;
    if (dynamicRoutingFeatureFlag && dynamicRoutingFeatureFlag.value) {
      enableDynamicRouting = true;
    }
    const menuProps = {
      openSettings: this.handleChange,
      shouldDialogOpen: this.shouldDialogOpen,
      isDefaultScenario: this.props.userData.userProfile.isDefaultScenario,
      currentTerminalId: this.props.userData.userProfile.terminal.id,
      isOptimizationRunning: this.props.CommonStore.isOptimizationRunning,
      isDataRefreshProgress: this.state.isDataRefreshProgress,
      isPublishInProgress: this.props.IBPlanningStore.isPublishInProgress,
      onTerminalChange: this.onTerminalChange,
      width: this.props.width,
      closeMenu: this.closeMainMenu,
      selectedRouteCount:
        this.props.IBPlanningStore.selectedRouteNameList.filter(
          (routeName) => routeName !== appConstants.UNRTD_ROUTENAME
        ).length,
      enableDynamicRouting: enableDynamicRouting,
      userProfile: this.userProfileData,
      userData: this.props.userData
    };
    const showNotificationHeaderIcon = !this.state.currentTabValue?.includes?.("reports")
    const isShipmentSelectionEnabled = this.isShipmentSelectionEnabled();
    return (
      <div>
        {this.state.currentTabValue &&
          this.state.currentTabValue != this.props.router.location.pathname && (
            <Navigate to={this.state.currentTabValue} />
          )}
        <AppBar position="sticky" className="appHeader" classes={{ root: classes.headerStyles }}>
          <Toolbar variant="dense" classes={{ gutters: classes.gutters }}>
            <div>
              <IconButton
                disableRipple={true}
                color="primary"
                onClick={this.openModuleSwitcher}
                data-automationid="hamburger-menu">
                <Tooltip title="Switch Modules">
                  <i className={`${classes.moduleSwitcher} icon-icon_burger_menu`} />
                </Tooltip>
              </IconButton>
              <ModuleSwitcher
                menuAnchor={moduleSwitcherAnchor}
                onClose={this.onModuleSwitcherClose}
                handleModuleChange={this.handleChange}
                userProfile={this.props.userData.userProfile}
              />
            </div>
            <img className={classes.rmaxLogo} src="../../images/RouteMax_Logo_Orange_v2.svg" />
            <Tabs
              value={
                this.tabValues.includes(this.state.currentTabValue)
                  ? this.state.currentTabValue
                  : false
              }
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator
              }}
              onChange={this.handleChange}>
              <Tab
                value={this.tabValues[0]}
                label="Shipment Management"
                id="ShipmentManagementHeader"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected
                }}
              />
              <Tab
                value={this.tabValues[1]}
                label="Route Planning"
                id="RoutesPlanningHeader"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected
                }}
              />
              <Tab
                value={this.tabValues[2]}
                label="Customer Management"
                id="CustomerManagementHeader"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected
                }}
              />
            </Tabs>
            <div className={classes.grow}>
              <span
                className={
                  this.props.configJSON && !this.props.configJSON.isProduction
                    ? classes.wrongEnvironmentWarning
                    : classes.hideWarning
                }
                data-automationid="wrong-env-text">
                <div>TEST ENVIRONMENT</div>
                <span
                  className={classes.prodLink}
                  onClick={() => window.open(this.props.configJSON.productionURL, '_self')}>
                  Click here for Live App
                </span>
              </span>
            </div>
            <ShipmentSelectionMenu
              open={Boolean(this.state.menuAnchor)}
              menuAnchor={this.state.menuAnchor}
              onClose={this.closeMenu}
              openSettings={this.handleChange}
              openAddUpdateProToPlan={this.openAddUpdateProToPlan}
              isDefaultScenario={this.props.userData.userProfile.isDefaultScenario}
              configJSON={this.props.configJSON}
            />
            <div className={classes.headerIcons}>
              {this.props.configJSON?.selectShipmentURL ? (
                <ShipmentSelection url={this.props.configJSON.selectShipmentURL} />
              ) : null}
              <div className={classes.refreshContainer}>
                <div
                  className={classes.refreshText}
                  data-automationid="plan-date"
                  onClick={isShipmentSelectionEnabled ? this.openMenu : null}>
                  <span className={classes.planDate}>
                    Plan date: {formatDate(this.props.userData.userProfile.planDate, 'MM/dd')}{' '}
                  </span>
                  <span className={classes.scenarioDetail}>
                    {' '}
                    {this.props.userData.userProfile.scenarioName}{' '}
                    {`(${this.props.userData.userProfile.scenarioID})`}{' '}
                  </span>
                  {/* TODO: Keep dynamic value here Refreshed 15 min ago */}
                </div>
                <div className={classes.refreshIconContainer}>
                  <RefreshIconButton
                    isRefreshing={this.state.isDataRefreshProgress}
                    defaultTooltip=""
                    refreshingTooltip=""
                  />
                </div>
              </div>
              <div className={classes.rightNavMenuContainer}>
                <RightNavigationMenu
                  {...menuProps}
                  toggleNotificationPanel={this.toggleNotificationPanel}
                  showNotificationPanel={this.state.showNotificationPanel}
                  showNewShipmentsNotification={this.state.showNewShipmentsNotification}
                  unreadCount={this.state.newShipmentsUnreadCount}
                  handleAddClick={this.showAddNewShipments}
                  showNotificationHeaderIcon={showNotificationHeaderIcon}
                />
              </div>

              <Menu
                disablePortal={true}
                getContentAnchorEl={null}
                disableAutoFocusItem={true}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={Boolean(mainMenuAnchor)}
                anchorEl={mainMenuAnchor}
                onClose={this.closeMainMenu}
                MenuListProps={{ disablePadding: true }}
                classes={{
                  paper: classes.mainMenu
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <RightNavigationMenu
                  {...menuProps}
                  toggleNotificationPanel={this.toggleNotificationPanel}
                  showNotificationPanel={this.state.showNotificationPanel}
                  showNewShipmentsNotification={this.state.showNewShipmentsNotification}
                  unreadCount={this.state.newShipmentsUnreadCount}
                  handleAddClick={this.showAddNewShipments}
                  showNotificationHeaderIcon={showNotificationHeaderIcon}
                />
              </Menu>
            </div>

            <div className={classes.toggledMenu}>
              <IconButton
                color="inherit"
                className={classes.mainMenuButton}
                onClick={this.openMainMenu}>
                <Tooltip title="Main Menu">
                  <MoreVert style={{ fontSize: '21px' }} />
                </Tooltip>
              </IconButton>
            </div>
          </Toolbar>
          {
            //open dynamic routing feedback after dynamic routing dialog gets closed
            this.state.openDynamicRoutingFeedback && (
              <DynamicRoutingFeedback
                show={this.state.openDynamicRoutingFeedback}
                dynamicRoutingOutputData={this.state.dynamicRoutingOutputData}
                onClose={this.closeDynamicRoutingFeedback}
                optimizationRunTimeDetails={this.optimizationRunTimeDetails ?? {}}
                themeName={this.props.theme.themeName}
              />
            )
          }
          <Suspense fallback={<AppLoading />}>
            {this.state.isDialogOpen &&
              this.state.title &&
              this.getDialogComponent(this.state.title)}
          </Suspense>
        </AppBar>
        {this.state.showAddNewShipments && (
          <AddNewShipmentsOverlay
            open
            glEventHub={this.props.glEventHub}
            userProfile={this.props.userData.userProfile}
            serviceLevelList={this.props.IBPlanningStore.serviceLevelList}
            handleCancel={this.closeAddNewShipmentsPopup}
          />
        )}
        <ETLComponent
          onDataLoad={this.updateDataRefreshingStatus}
          isValidFirstPush={this.isValidFirstPush}
          onETLSuccess={this.refreshIBPlanningData}
        />
        <ParameterListener scenarioId={this.props.userData.userProfile.scenarioID} />
      </div>
    );
  }
}
export default compose(
  withWidth(),
  withTheme(),
  withStyles(styles),
  withUserProfile,
  withSnackbar,
  withAppConfig, 
  withRouter
)(IbplanningHeader);
